import moment, { DurationInputArg1 } from 'moment-timezone';
import { timezone } from '../config/constants';
import { DataPoint } from '../store/index';

/**
 * Helper function to generate timestamps to end of selected timeframe
 * @param start
 * @param end
 * @param level
 * @param frame
 * @param data
 * @param isTemperatureData
 * @returns
 */
export const fillDates = (
  start: string,
  end: string,
  level: string,
  frame: string,
  data?: Array<DataPoint>,
  isTemperatureData?: boolean
): Array<DataPoint> | null => {
  // Return data contains only timestamps with datapoints
  // Create array of all dates and combine it with return data
  if (!data) return null;

  const getDates = (
    level: string,
    start: string,
    end: string
  ): { currentDate: moment.Moment; endDate: moment.Moment; timeUnit: string } => {
    if (level === 'month') {
      return {
        timeUnit: 'month',
        currentDate: moment(start)
          .tz(timezone)
          .startOf('month'),
        endDate: moment(end)
          .tz(timezone)
          .startOf('month')
      };
    } else if (level === 'hour') {
      if (frame === 'custom' || frame === 'week') {
        return {
          timeUnit: 'hour',
          currentDate: moment(start)
            .tz(timezone)
            .startOf('day'),
          endDate: moment(data[data.length - 1].ts)
            .tz(timezone)
            .endOf('day')
        };
      } else {
        return {
          timeUnit: 'hour',
          currentDate: moment(start)
            .tz(timezone)
            .startOf('day'),
          endDate: moment(end)
            .tz(timezone)
            .endOf('day')
        };
      }
    } else if (level === 'quarter-hour') {
      if (frame === 'custom' || frame === 'week') {
        return {
          timeUnit: 'minute',
          currentDate: moment(start)
            .tz(timezone)
            .startOf('day'),
          endDate: moment(data[data.length - 1].ts)
            .tz(timezone)
            .endOf('day')
        };
      } else {
        return {
          timeUnit: 'minute',
          currentDate: moment(start)
            .tz(timezone)
            .startOf('hour'),
          endDate:
            frame === 'hour'
              ? moment(end)
                  .tz(timezone)
                  .endOf('hour')
              : moment(end)
                  .tz(timezone)
                  .endOf('day')
        };
      }
    } else {
      return {
        timeUnit: 'day',
        currentDate: moment(start)
          .tz(timezone)
          .startOf('day'),
        endDate: moment(end)
          .tz(timezone)
          .startOf('day')
      };
    }
  };

  // eslint-disable-next-line prefer-const
  let { timeUnit, endDate, currentDate } = getDates(level, start, end);

  const dateArray = [];
  let increment = '1' as DurationInputArg1;
  if (level === 'month') {
    while (currentDate.isSameOrBefore(endDate)) {
      const monthData = data.filter(d =>
        moment(d.ts)
          .tz(timezone)
          .isSame(currentDate, 'month')
      );
      const totalV = monthData.reduce((sum, record) => sum + record.v, 0);
      const totalVp = monthData.reduce((sum, record) => sum + (record.vp ? record.vp : 0), 0);

      if (isTemperatureData) {
        dateArray.push({
          ts: currentDate.toISOString(true),
          v: totalV
        });
      } else {
        dateArray.push({
          ts: currentDate.toISOString(true),
          v: totalV,
          vp: totalVp
        });
      }
      currentDate.add(1, 'month');
    }
  } else {
    while (currentDate.isSameOrBefore(endDate)) {
      if (isTemperatureData) {
        dateArray.push({
          ts: currentDate.toISOString(true),
          v: 0
        });
      } else {
        dateArray.push({
          ts: currentDate.toISOString(true),
          v: 0,
          vp: 0
        });
      }
      if (timeUnit === 'minute') {
        increment = '15' as DurationInputArg1;
      }
      currentDate = currentDate.add(increment, timeUnit as moment.DurationInputArg2);
    }
  }

  const formattedData: Array<DataPoint> = data.map(d => {
    d.ts = moment(d.ts)
      .tz(timezone)
      .toISOString(true);
    d.v = Number(d.v);
    if (d.vp) {
      d.vp = Number(d.vp);
    }
    return d;
  });

  for (let i = 0; i < dateArray.length; i++) {
    for (let j = 0; j < formattedData.length; j++) {
      if (dateArray[i].ts == formattedData[j].ts) {
        dateArray[i] = formattedData[j];
        break;
      }
    }
  }
  return dateArray;
};

export default fillDates;
